import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-058b377e")

_pushScopeId("data-v-058b377e")
const _hoisted_1 = { class: "award-store-container" }
const _hoisted_2 = { class: "list-wrapper" }
const _hoisted_3 = { class: "left-wrapper" }
const _hoisted_4 = { class: "left-item left-correct" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "答对题数：", -1)
const _hoisted_6 = { class: "left-item left-rank" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "本次排名：", -1)
const _hoisted_8 = { class: "left-time" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")
  const _component_Back = _resolveComponent("Back")
  const _component_PopInner = _resolveComponent("PopInner")

  return (_openBlock(), _createBlock(_component_PopInner, null, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Title, { text: `答题纪录` }),
        _createVNode(_component_Back, { onAction: _ctx.goBack }, null, 8, ["onAction"]),
        _createVNode("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (i, k) => {
            return (_openBlock(), _createBlock("div", {
              class: "list-item",
              key: k,
              onClick: _withModifiers(($event: any) => (_ctx.doAction(i)), ["stop","prevent"])
            }, [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode("span", null, _toDisplayString(i.correct), 1)
                ]),
                _createVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode("span", null, _toDisplayString(i.rank), 1)
                ]),
                _createVNode("div", _hoisted_8, [
                  _createVNode("span", null, _toDisplayString(i.time), 1)
                ]),
                (i.isActive >= 0)
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      class: `list-action ${!i.isActive ? '' : 'non-active'}`
                    }, [
                      _createVNode("span", null, _toDisplayString(!i.isActive ? "去抽奖" : "已抽奖"), 1)
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", {
                class: `right-wrapper rank-${i.rankIndex}`
              }, [
                _createVNode("img", {
                  src: `${_ctx.rootUrl}/answer/answer_rank_${i.rankIndex}.png`
                }, null, 8, ["src"]),
                _createVNode("span", null, _toDisplayString(i.rankName), 1)
              ], 2)
            ], 8, ["onClick"]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
})